<template>
  <div class="tag">
    <template v-if="getTag.length">
      <el-tag :class="{'tag-entity':true,'tag-overflow':getOverflow}"
              v-for="row in getTag"
              :key="row.id"
              :effect="getLabelStyle (row) | effectFilter"
              :type="getLabelStyle (row) | typeFilter">
        {{  getLabelName (row)  }}
      </el-tag>
    </template>
    <template v-else>
      <span>-</span>
    </template>
  </div>
</template>

<script>

export default {
  name: "tag",
  props: ["tableData", "scope"],
  computed: {
    getTag () {
      if ((typeof this.scope.row[this.tableData.bind]) == 'string') {
        return Array.of(this.scope.row)
      }
      return this.scope.row[this.tableData.bind]
    },
    getOverflow () {
      if (this.tableData.hasOwnProperty('tagEllipsis')) return this.tableData.tagEllipsis
      return true
    }
  },
  methods: {
    getLabelStyle (row) {
      const { tableData } = this
      if (tableData && tableData.labelStyleKey) return row[tableData.labelStyleKey]
      return row.labelStyle
    },
    getLabelName (row) {
      const { tableData } = this
      if (tableData && tableData.labelNameKey) return row[tableData.labelNameKey]
      return row.labelName
    }
  },
  filters: {
    typeFilter: function (value) {
      return value.split('_')[0];
    },
    effectFilter: function (value) {
      return value.split('_')[1];
    },
  },
  mounted () {
  },
}
</script>

<style lang="scss" scoped>
.tag {
  display: flex;
}
.tag-entity {
  margin-right: 5px;
}
.tag-overflow {
  max-width: calc(500px / 3 - 15px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>